import Slider from 'react-slick';
import styles from './mobileContent.module.scss';
import {
  mobileProject,
  mobileEcomerce,
  BlockChain,
  sale,
  videoCall,
  SlideArrowRight,
  SlideArrowLeft,
} from '../../image';
// import components
import SlideItem from '../slide-item/slideItem';
import ContentVideo from '../content-video';
import ContentText from '../content-text';
import { useEffect } from 'react';
export default function MobileContent(props) {
  const SlickArrowLeft = ({ className, style, onClick }) => (
    <button
      className={`${className} ${styles['left__arrow']} ${styles['clear__button']}`}
      style={{
        fontSize: '40px',
        zIndex: '1',
        height: '40px',
        width: '40px',
        opacity: '1',
        color: 'White',
      }}
      onClick={onClick}
    >
      <SlideArrowLeft />
    </button>
  );
  const SlickArrowRight = ({ className, onClick }) => (
    <button
      className={`${className} ${styles['right__arrow']} ${styles['clear__button']}`}
      style={{
        fontSize: '40px',
        zIndex: '1',
        height: '40px',
        width: '40px',
        opacity: '1',
        color: 'White',
      }}
      onClick={onClick}
    >
      <SlideArrowRight />
    </button>
  );
  //slide setting
  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
  };
  //slide item content
  const slideContent = [
    {
      src: mobileEcomerce,
    },
    {
      src: sale,
    },
    {
      src: BlockChain,
    },
    {
      src: sale,
    },
  ];
  const handleBtnCallback = () => {
    props.setShowNavigation(true);
    document
      .querySelector(`.${styles['text-content']}`)
      .classList.add(styles['remove']);
    document
      .querySelector(`.${styles['video-content']}`)
      .classList.add(styles['floatleft']);
    document
      .querySelector(`.${styles['slide-items']}`)
      .classList.add(styles['remove']);
    document.querySelector(`ul`).style.right = '60px';
  };

  useEffect(() => {
    if (!props.showNavigation) {
      document
        .querySelector(`.${styles['text-content']}`)
        .classList.remove(styles['remove']);
      document
        .querySelector(`.${styles['video-content']}`)
        .classList.remove(styles['floatleft']);
      document
        .querySelector(`.${styles['slide-items']}`)
        .classList.remove(styles['remove']);
      document.querySelector(`ul`).style.right = '-100%';
    }
  }, [props.showNavigation]);
  return (
    <>
      <div className={styles['mobile']}>
        <div className={styles['mobile-main-content']}>
          <div className={styles['text-content']}>
            <ContentText
              title={props.content && props.content.title}
              content={props.content && props.content.content}
              btnText="TÌM HIỂU THÊM"
              btnCallback={handleBtnCallback}
            />
          </div>
          <div className={styles['video-content']}>
            <div data-aos="fade-up" data-aos-duration="2000">
              <ContentVideo
                imageCover={props.content && props.content.imgVideo}
                video={props.content && props.content.linkVideo}
                id="mobileVideo"
                coverClass="mobileCover"
              />
            </div>
          </div>
          <div className={styles['mobile-option']}>
            <ul>
              {props.content
                ? props.content.details.listContent.map((e) => <li>{e}</li>)
                : ''}
            </ul>
          </div>
        </div>
        <div className={styles['product-slide']}>
          <div
            data-aos="fade-left"
            data-aos-duration="2000"
            data-aos-delay="1000"
          >
            <div className={styles['slide-items']}>
              <Slider {...settings}>
                {props.slide &&
                  props.slide.map((val, index) => (
                    <SlideItem
                      src={val}
                      number={index + 1}
                      display={props.display}
                    />
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
